import {normalize} from "@sfs/utils/stringUtilities";
import {Select, SelectProps} from "antd";
import React from "react";
import {FormItem, FormItemProps} from "./FormItem";
import {useAutoFocusRef} from "../hooks/useAutoFocusRef";
import {reactNodeToText} from "@sfs/components/ListFilters/reactNodeToText";

export const SelectComponent = (props: SelectProps) => {
  // autoFocus feeds useAutoFocusRef only — never forward it to antd Select, whose
  // native autofocus attribute focuses while rc popups are still pre-positioned
  // off-screen and scrolls the page to reach them.
  const {autoFocus, ...selectProps} = props;
  const autoFocusRef = useAutoFocusRef(autoFocus);
  return (
    <Select
      ref={autoFocusRef}
      filterOption={(inputValue, option) =>
        normalize(reactNodeToText(option?.label)).indexOf(normalize(inputValue)) !== -1
      }
      // prevent selection with Enter to trigger full page validation
      onKeyDown={(event) => event.key === "Enter" && event.stopPropagation()}
      {...selectProps}
    />
  );
};

export const SelectInput = (props: FormItemProps<SelectProps>) => (
  <FormItem {...props}>
    <SelectComponent variant="borderless" />
  </FormItem>
);
